/**
 * Translation Exports
 *
 * Central export point for all translations.
 */

export { EN_TRANSLATIONS } from './en';
export { AR_TRANSLATIONS } from './ar';
